import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SiteProvider } from '@/context/SiteContext';
import { Layout } from '@/components/Layout';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import ServiceDetail from '@/pages/ServiceDetail';
import Projects from '@/pages/Projects';
import ProjectDetail from '@/pages/ProjectDetail';
import Locations from '@/pages/Locations';
import Clients from '@/pages/Clients';
import Equipment from '@/pages/Equipment';
import Contact from '@/pages/Contact';

import AdminLogin from '@/pages/admin/AdminLogin';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminEnquiries from '@/pages/admin/AdminEnquiries';
import CrudManager from '@/pages/admin/CrudManager';
import SingletonEditor from '@/pages/admin/SingletonEditor';

function App() {
  return (
    <div className='App'>
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path='/' element={<Home />} />
              <Route path='/about' element={<About />} />
              <Route path='/services' element={<Services />} />
              <Route path='/services/:slug' element={<ServiceDetail />} />
              <Route path='/projects' element={<Projects />} />
              <Route path='/projects/:slug' element={<ProjectDetail />} />
              <Route path='/locations' element={<Locations />} />
              <Route path='/clients' element={<Clients />} />
              <Route path='/equipment' element={<Equipment />} />
              <Route path='/contact' element={<Contact />} />
            </Route>

            <Route path='/admin' element={<AdminLogin />} />
            <Route path='/admin' element={<AdminLayout />}>
              <Route path='dashboard' element={<AdminDashboard />} />
              <Route path='enquiries' element={<AdminEnquiries />} />
              <Route path='content/:collection' element={<CrudManager />} />
              <Route path='singleton/:name' element={<SingletonEditor />} />
            </Route>

            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </div>
  );
}

export default App;
